import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardObjectComponent } from '@app/home/card-object/card-object.component';
import { ButtonComponent } from '@app/shared/button/button.component';
import { PrimeNgModule } from '@shared/modules/prime-ng/prime-ng.module';
import { PaginatorModule } from 'primeng/paginator';
import { SettingsService } from '@app/settings.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-object-list',
  templateUrl: './object-list.component.html',
  styleUrls: ['./object-list.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonComponent, CardObjectComponent, PaginatorModule, PrimeNgModule],
})
export class ObjectListComponent implements OnInit {
  @Input() items: any[] = [];
  @Input() header: string;
  @Input() totalCount: number;
  @Input() typeViewMore: 'pagination' | 'loadMore' | 'none' = 'loadMore';
  @Input() paginationSettings: any;
  @Output() getMore: EventEmitter<any> = new EventEmitter<any>();
  @Output() changePage: EventEmitter<any> = new EventEmitter<any>();

  isMobile$: Observable<boolean>;

  constructor(
    private _settingsService: SettingsService,
    private _router: Router,
  ) {}
  
  ngOnInit() {
    this.isMobile$ = this._settingsService.isMobile();
  }

  getMoreData() {
    this.getMore.emit();
  }

  public navigateToDetailsPage(applicationId: number): void {
    this._router.navigate(['/real-property/', applicationId]);
  }
}
